export default __webpack_public_path__ + "static/media/8.a2aa4486.jpg";